import React from "react";
import ReactExport from 'react-export-excel';
import { ASSEMBLYORCOMPONENTSRFQ, BOUGHTOUTPARTSRFQ, CBCADDMORE, CBCADDMOREOPERATION, CBCTypeId, RAWMATERIALSRFQ, SAP_PUSH, VBCADDMORE, VBCADDMOREOPERATION, VBCTypeId, ZBCADDMORE, ZBCADDMOREOPERATION, ZBCTypeId } from "../../config/constants";
import {
    Fuel, FuelTempData,
    RMDomesticZBC, RMDomesticZBCTempData, RMDomesticVBC, RMDomesticVBCTempData,
    RMImportZBC, RMImportZBCTempData, RMImportVBC, RMImportVBCTempData,
    RMSpecification, RMSpecificationXLTempData,
    Vendor, VendorTempData,
    Labour, LabourTempData,
    Overhead, OverheadTempData, OverheadVBC, OverheadVBC_TempData, OverheadCBC, OverheadCBC_TempData, Profit, ProfitTempData, ProfitVBC, ProfitTempDataVBC, ProfitCBC, ProfitTempDataCBC,
    ZBCOperation, ZBCOperationTempData, VBCOperation, VBCOperationTempData,
    MachineZBC, MachineZBCTempData, MachineVBC, MachineVBCTempData, MHRMoreZBC, MHRMoreZBCTempData,
    PartComponent, PartComponentTempData, ProductComponent, ProductComponentTempData, BOMUploadTempData, BOMUpload,
    BOP_ZBC_DOMESTIC, BOP_ZBC_DOMESTIC_TempData, BOP_VBC_DOMESTIC, BOP_VBC_DOMESTIC_TempData,
    BOP_ZBC_IMPORT, BOP_ZBC_IMPORT_TempData, BOP_VBC_IMPORT, BOP_VBC_IMPORT_TempData,
    VOLUME_ACTUAL_ZBC, VOLUME_ACTUAL_ZBC_TEMPDATA, VOLUME_ACTUAL_VBC, VOLUME_ACTUAL_VBC_TEMPDATA,
    VOLUME_BUDGETED_ZBC, VOLUME_BUDGETED_ZBC_TEMPDATA, VOLUME_BUDGETED_VBC, VOLUME_BUDGETED_VBC_TEMPDATA,
    ZBCInterestRate, ZBCInterestRateTempData, VBCInterestRate, VBCInterestRateTempData, RMDomesticCBC, RMDomesticCBCTempData, RMImportCBC, RMImportCBCTempData, MachineCBC, MachineCBCTempData, BOP_CBC_DOMESTIC, BOP_CBC_IMPORT, BOP_CBC_IMPORT_TempData, BOP_CBC_DOMESTIC_TempData, VOLUME_BUDGETED_CBC_TEMPDATA, VOLUME_ACTUAL_CBC_TEMPDATA, CBCOperationTempData, VOLUME_ACTUAL_CBC, VOLUME_BUDGETED_CBC, CBCOperation, CBCInterestRateTempData, CBCInterestRate, AddRFQUpload, AddRFQTempData, BUDGET_ZBC, BUDGET_ZBC_TEMPDATA, BUDGET_VBC_TEMPDATA, BUDGET_VBC, BUDGET_CBC_TEMPDATA, BUDGET_CBC, ZBCOperationSmallForm, VBCOperationSmallForm, CBCOperationSmallForm, DETAILED_BOP, BOP_DETAILED_DOMESTIC, BOP_DETAILED_DOMESTIC_TempData, BOP_DETAILED_IMPORT, BOP_DETAILED_IMPORT_TempData,
    IndexCommodityListing, IndexCommodityListingTempData, CommodityInIndexListing, CommodityInIndexListingTempData,
    StandardizedCommodityNameTempData, StandardizedCommodityNameListing,
    CommodityStandardTempData,
    IndexDataListingTempData,
    IndexDataListing,
    CommodityStandard,
    AddBoughtOutPartsHeaderData,
    AddRawMaterialHeaderData,
    AddAssemblyOrComponentHeaderData,
    AddBoughtOutPartsTempData,
    AddRawMaterialTempData,
    AddAssemblyOrComponentTempData,
    AddAssemblyOrComponentAdditionalInfoTempData,
    AddAssemblyOrComponentAdditionalInfoHeaderData,
    SAP_PUSH_HEADER_DATA,
    SAP_PUSH_TEMP_DATA,
    PartFamily,
    PartFamilyTempData,
} from '../../config/masterData';
import { checkVendorPlantConfigurable, getConfigurationKey, RFQ_KEYS, showBopLabel, updateBOPValues } from "../../helper";
import { checkSAPCodeinExcel } from "./DownloadUploadBOMxls";
import { IsShowFreightAndShearingCostFields } from "../../helper";
import { localizeHeadersWithLabels } from "../../helper/core";
import { withLocalization, useWithLocalization } from "../../helper/core";
import { withTranslation } from "react-i18next";


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const bopMasterName = showBopLabel();

export const checkRM_Process_OperationConfigurable = (excelData) => {

    return excelData.filter((el) => {
        if (getConfigurationKey().IsAutoGeneratedRawMaterialCode && el.value === 'RawMaterialCode') return false;
        if (getConfigurationKey().IsAutoGeneratedProcessCode && el.value === 'ProcessCode') return false;
        if (getConfigurationKey().IsAutoGeneratedOperationCode && el.value === 'OperationCode') return false;
        if (getConfigurationKey().IsAutoGeneratedMachineNumber && el.value === 'MachineNo') return false;
        if (IsShowFreightAndShearingCostFields() === false) {
            const freightAndShearingCostKeys = ['FreightCost', 'ShearingCost', 'RMFreightCost', 'RMShearingCost', 'RawMaterialFreightCostConversion', 'RawMaterialShearingCostConversion '];
            if (freightAndShearingCostKeys.includes(el.value)) return false;
        }

        if (getConfigurationKey().IsShowCRMHead === false) {
            const crmHeadKeys = ['LoanCRMHead', 'InterestCRMHead', 'WorkingShiftCRMHead', 'DepreciationCRMHead', 'AnnualMaintanceCRMHead', 'AnnualConsumableCRMHead', 'AnnualInsuranceCRMHead', 'BuildingCRMHead', 'MachineFloorCRMHead', 'OtherYearlyCRMHead', 'FuelCRMHead', 'PowerCRMHead', 'LabourCRMHead']

            for (const index in crmHeadKeys) {
                if (el.value === crmHeadKeys[index]) {
                    return false; // Exclude the element if el.value matches any entry in the array
                }
            }
        }
        return true; // Include the element if none of the conditions above are met
    });
}

export const checkLabourRateConfigure = (excelData) => {
    return excelData.filter((el) => {
        if (getConfigurationKey().IsOperationLabourRateConfigure === false) {
            if (el.value === 'LabourRate') return false;
        }
        if (getConfigurationKey().IsDestinationPlantConfigure === false) {
            if (el.value === 'DestinationPlant') return false;
            if (el.value === 'DestinationPlantCode') return false;
            if (el.value === 'PlantCode') return false;
        }

        if (getConfigurationKey().IsAutoGeneratedOperationCode === true) {
            if (el.value === 'OperationCode') return false;
        }
        if (getConfigurationKey().IsShowDetailedOperationBreakup === false) {
            const operationKeys = ['OperationType', 'WeldingRate', 'Consumption', 'Note'];
            if (operationKeys.includes(el.value)) return false;
        }
        return true;
    })
}
export const checkInterestRateConfigure = (excelData) => {
    return excelData.filter((el) => {
        if (getConfigurationKey().IsShowRawMaterialInOverheadProfitAndICC === false) {
            if (el.value === 'RawMaterialName') return false;
            if (el.value === 'RawMaterialGrade') return false;
        }
        if (!(getConfigurationKey()?.PartAdditionalMasterFields?.IsShowPartFamily)) {
            if (el.value === 'PartFamilyCode') return false;
        }
        return true;
    })
}
/**
* @method checkVendorPlantConfig
* @description CONDITION TO CHECK:- TO AVOID VENDOR PLANT IF NOT CONFIGURABLE FROM INITIALIZER
*/
export const checkVendorPlantConfig = (excelData, type = '', isBop = false, isVendor = false) => {





    return excelData.filter((el) => {
        if (checkVendorPlantConfigurable() === false) {
            if (el.value === 'VendorPlant') return false;
            /**********************DON'T REMOVE NOW MAY BE USED LATER**********************************/
            // if (el.value === 'LabourRate') return false;
            // if (el.value === 'VendorName') return false;
            // if (el.value === 'VendorPlantCode') return false;
            // if (el.value === 'DestinationPlant') return false;
            // if (el.value === 'DestinationPlantCode') return false;

        }
        if (IsShowFreightAndShearingCostFields() === false) {
            const freightAndShearingCostKeys = ['FreightCost', 'ShearingCost', 'RMFreightCost', 'RMShearingCost', 'RawMaterialFreightCostConversion', 'RawMaterialShearingCostConversion '];
            if (freightAndShearingCostKeys.includes(el.value)) return false;
        }
        if (getConfigurationKey().IsAutoGeneratedMachineNumber && el.value === 'MachineNo') return false;
        if (getConfigurationKey().IsAutoGeneratedRawMaterialCode && el.value === 'RawMaterialCode') return false;
        if (getConfigurationKey().IsDestinationPlantConfigure === false) {
            if (el.value === 'DestinationPlant') return false;
            if (el.value === 'DestinationPlantCode') return false;
            if (el.value === 'PlantCode') return false;
        }
        if (getConfigurationKey().IsAutoGeneratedProcessCode === true) {
            if (el.value === 'ProcessCode') return false;
        }
        if (type === CBCTypeId && getConfigurationKey().IsCBCApplicableOnPlant === false) {
            if (el.value === 'DestinationPlantName') return false;
            if (el.value === 'DestinationPlantCode') return false;
            if (el.value === 'PlantCode') return false;
        }
        if (getConfigurationKey().IsShowClientVendorBOP === false) {
            if (el.value === 'IsClientVendorBOP') return false;
        }
        if (isBop && getConfigurationKey().IsBoughtOutPartCostingConfigured === false) {
            if (el.value === 'IsBreakupBoughtOutPart') return false;
            if (el.value === 'TechnologyName') return false;
        }
        if (getConfigurationKey().IsMinimumOrderQuantityVisible === false) {
            if (el.value === 'NumberOfPieces') return false;
        }
        if (isVendor && !getConfigurationKey().IsCriticalVendorConfigured) {
            if (el.value === "IsCriticalVendor") return false;
            if (el.value === "Technology") return false;
            if (el.value === "PlantCode") return false;
        }
        if (getConfigurationKey().IsAutoGeneratedBOPNumber === true) {
            if (el.value === "BoughtOutPartNumber") return false;
        }
        if (getConfigurationKey().IsShowPaymentTermsFields === false) {
            if (el.value === 'PaymentTerm') return false;
        }
        if (getConfigurationKey().IsSAPCodeRequired === false) {
            if (el.value === 'SAPCode') return false;
        }
	if (!(getConfigurationKey()?.PartAdditionalMasterFields?.IsShowPartFamily)) {
            if (el.value === 'PartFamilyCode') return false;
        }
        return true;
    })
}
export const addDynamicModelType = (list, modelText) => {
    let arr = []
    list && list?.map(item => {
        item.ModelType = modelText
        arr.push(item)
    })
    return arr
}
class Downloadxls extends React.Component {
    constructor(props) {
        super(props);
        this.localizeHeaders = this.localizeHeaders.bind(this);

    }

    localizeHeaders(headers) {
        return localizeHeadersWithLabels(headers, this.props.t);
    }
    /**
    * @method renderSwitch
    * @description Switch case for different xls file head according to master
    */
    renderSwitch = (master) => {
        let updatedLabels
        switch (master) {
            case 'RM Specification':
                const localizedHeaders = this.localizeHeaders(RMSpecification);
                return this.returnExcelColumn(checkRM_Process_OperationConfigurable(localizedHeaders), RMSpecificationXLTempData);
            case 'Vendor':
                const localizedVendorHeaders = this.localizeHeaders(Vendor);
                ({ updatedLabels } = updateBOPValues(localizedVendorHeaders, VendorTempData, bopMasterName, 'label'));

                return this.returnExcelColumn(checkVendorPlantConfig(updatedLabels, '', false, true), VendorTempData);
            case 'Overhead':
                const localizedOverheadHeaders = this.localizeHeaders(Overhead);
                return this.returnExcelColumn(localizedOverheadHeaders, addDynamicModelType(OverheadTempData, this.props?.modelText));
            case 'Index Data':
                const localizedIndexDataHeaders = this.localizeHeaders(IndexDataListing);
                return this.returnExcelColumn(localizedIndexDataHeaders, IndexDataListingTempData);
            case 'Index':
                const localizedIndexHeaders = this.localizeHeaders(IndexCommodityListing);
                return this.returnExcelColumn(localizedIndexHeaders, IndexCommodityListingTempData);
            case 'Commodity (In Index)':
                const localizedCommodityInIndexHeaders = this.localizeHeaders(CommodityInIndexListing);
                return this.returnExcelColumn(localizedCommodityInIndexHeaders, CommodityInIndexListingTempData);
            case 'Commodity Standardization':
                const localizedCommodityStandardizationHeaders = this.localizeHeaders(StandardizedCommodityNameListing);
                return this.returnExcelColumn(localizedCommodityStandardizationHeaders, StandardizedCommodityNameTempData);
            case 'Commodity Standard':
                const localizedCommodityStandardHeaders = this.localizeHeaders(CommodityStandard);
                return this.returnExcelColumn(localizedCommodityStandardHeaders, CommodityStandardTempData);
            case 'Fuel':
                const localizedFuelHeaders = this.localizeHeaders(Fuel);
                return this.returnExcelColumn(localizedFuelHeaders, FuelTempData);
            case 'Profit':
                const localizedProfitHeaders = this.localizeHeaders(Profit);
                return this.returnExcelColumn(localizedProfitHeaders, addDynamicModelType(ProfitTempData, this.props?.modelText));
            case 'Labour':
                const localizedLabourHeaders = this.localizeHeaders(Labour);
                return this.returnExcelColumn(localizedLabourHeaders, LabourTempData);
            case 'Part Component':
                const localizedPartComponentHeaders = this.localizeHeaders(PartComponent);
                return this.returnExcelColumn(checkSAPCodeinExcel(localizedPartComponentHeaders), checkSAPCodeinExcel(PartComponentTempData));
            case 'Part Family':
                const localizedPartFamilyHeaders = this.localizeHeaders(PartFamily);
                return this.returnExcelColumn(checkSAPCodeinExcel(localizedPartFamilyHeaders), checkSAPCodeinExcel(PartFamilyTempData));
            case SAP_PUSH:
                const localizedSAPPushHeaders = this.localizeHeaders(SAP_PUSH_HEADER_DATA);
                return this.returnExcelColumn(localizedSAPPushHeaders, SAP_PUSH_TEMP_DATA);
            case 'Product Component':
                const localizedProductComponentHeaders = this.localizeHeaders(ProductComponent);
                return this.returnExcelColumn(localizedProductComponentHeaders, ProductComponentTempData);
            case 'BOM':
                const localizedBOMHeaders = this.localizeHeaders(BOMUpload);
                return this.returnExcelColumn(localizedBOMHeaders, BOMUploadTempData);


            case BOUGHTOUTPARTSRFQ:
                const localizedBoughtOutPartsHeaders = this.localizeHeaders(AddBoughtOutPartsHeaderData);
                return this.returnExcelColumn(localizedBoughtOutPartsHeaders, AddBoughtOutPartsTempData);
            case RAWMATERIALSRFQ:
                const localizedRawMaterialHeaders = this.localizeHeaders(AddRawMaterialHeaderData);
                return this.returnExcelColumn(localizedRawMaterialHeaders, AddRawMaterialTempData);

            case ASSEMBLYORCOMPONENTSRFQ:
                const headers = !RFQ_KEYS?.SHOW_N100_HAVELLS
                    ? AddAssemblyOrComponentHeaderData.filter(h =>
                        !['PartDesignSourceName', 'N100Timeline'].includes(h.value)
                    )
                    : AddAssemblyOrComponentHeaderData;
                const templateData = !RFQ_KEYS?.SHOW_N100_HAVELLS
                    ? AddAssemblyOrComponentTempData.map(({ PartDesignSourceName, N100Timeline, ...rest }) => rest)
                    : AddAssemblyOrComponentTempData;
                return this.returnExcelColumn(this.localizeHeaders(headers), templateData);


            //return this.returnCombinedExcelColumn(AddAssemblyOrComponentHeaderData, AddAssemblyOrComponentTempData, AddAssemblyOrComponentAdditionalInfoHeaderData, AddAssemblyOrComponentAdditionalInfoTempData);
            default:
                return 'foo';
        }
    }


    // returnCombinedExcelColumn = (headerData1, tempData1, headerData2, tempData2) => {
    //     const { fileName } = this.props;

    //     // Combine the two sets of data
    //     const combinedHeaderData = [...headerData1, ...headerData2];
    //     const combinedTempData = tempData1.map((item, index) => ({
    //         ...item,
    //         ...(tempData2[index] || {})
    //     }));

    //     return (
    //         <ExcelSheet data={combinedTempData} name={fileName}>
    //             {combinedHeaderData.map((ele, index) => (
    //                 <ExcelColumn key={index} label={ele.label} value={ele.value} style={ele.style} />
    //             ))}
    //         </ExcelSheet>
    //     );
    // }
    // returnCombinedExcelColumn = (headerData1, tempData1, headerData2, tempData2) => {
    //     const { fileName } = this.props;

    //     return (
    //         <>
    //             <ExcelSheet data={tempData1} name={fileName}>
    //                 {headerData1.map((ele, index) => (
    //                     <ExcelColumn key={index} label={ele.label} value={ele.value} style={ele.style} />
    //                 ))}
    //             </ExcelSheet>
    //             <ExcelSheet data={tempData2} name={`${fileName} - Additional Info`}>
    //                 {headerData2.map((ele, index) => (
    //                     <ExcelColumn key={index} label={ele.label} value={ele.value} style={ele.style} />
    //                 ))}
    //             </ExcelSheet>
    //         </>
    //     );
    // }

    /**
    * @method renderZBCSwitch
    * @description Switch case for different xls file head according to master
    */

    renderZBCSwitch = (master) => {
        let updatedLabels
        switch (master) {
            case 'RM':
                if (!this.props.isImport) {
                    const localizedRMHeaders = this.localizeHeaders(RMDomesticZBC);
                    return this.returnExcelColumn(checkRM_Process_OperationConfigurable(localizedRMHeaders), RMDomesticZBCTempData, true);
                } else {
                    const localizedRMHeaders = this.localizeHeaders(RMImportZBC);
                    return this.returnExcelColumn(checkRM_Process_OperationConfigurable(localizedRMHeaders), RMImportZBCTempData);
                }
            case 'Operation':
                const localizedOperationHeaders = this.localizeHeaders(ZBCOperationSmallForm);
                return this.returnExcelColumn(checkLabourRateConfigure(localizedOperationHeaders), ZBCOperationTempData, true);
            case 'Machine':
                const localizedMachineHeaders = this.localizeHeaders(MachineZBC);
                return this.returnExcelColumn(checkVendorPlantConfig(localizedMachineHeaders), MachineZBCTempData);
            case ZBCADDMORE:
            case VBCADDMORE:
            case CBCADDMORE:
                const localizedMHRMoreHeaders = this.localizeHeaders(MHRMoreZBC);
                return this.returnExcelColumn(checkRM_Process_OperationConfigurable(localizedMHRMoreHeaders), MHRMoreZBCTempData);
            case `${showBopLabel()} Domestic`:
                const localizedBOPHeaders = this.localizeHeaders(BOP_ZBC_DOMESTIC);
                ({ updatedLabels } = updateBOPValues(localizedBOPHeaders, BOP_ZBC_DOMESTIC_TempData, bopMasterName, 'label'));
                return this.returnExcelColumn(checkVendorPlantConfig(updatedLabels, '', true), BOP_ZBC_DOMESTIC_TempData);
            case `${showBopLabel()} Import`:
                const localizedBOPImportHeaders = this.localizeHeaders(BOP_ZBC_IMPORT);
                ({ updatedLabels } = updateBOPValues(localizedBOPImportHeaders, BOP_ZBC_IMPORT_TempData, bopMasterName, 'label'));
                return this.returnExcelColumn(checkVendorPlantConfig(updatedLabels, '', true), BOP_ZBC_IMPORT_TempData);

            case `Overhead`:
                const localizedOverheadHeaders = this.localizeHeaders(Overhead);
                return this.returnExcelColumn(localizedOverheadHeaders, addDynamicModelType(OverheadTempData, this.props?.modelText));
            case `Profit`:
                const localizedProfitHeaders = this.localizeHeaders(Profit);
                return this.returnExcelColumn(localizedProfitHeaders, addDynamicModelType(ProfitTempData, this.props?.modelText));
            case 'Actual Volume':
                const localizedVolumeHeaders = this.localizeHeaders(VOLUME_ACTUAL_ZBC);
                return this.returnExcelColumn(localizedVolumeHeaders, VOLUME_ACTUAL_ZBC_TEMPDATA);
            case 'Budgeted Volume':
                const localizedBudgetedVolumeHeaders = this.localizeHeaders(VOLUME_BUDGETED_ZBC);
                return this.returnExcelColumn(localizedBudgetedVolumeHeaders, VOLUME_BUDGETED_ZBC_TEMPDATA);
            case 'Interest Rate':
                const localizedInterestRateHeaders = this.localizeHeaders(ZBCInterestRate);
                return this.returnExcelColumn(localizedInterestRateHeaders, ZBCInterestRateTempData);
            case 'Budget':
                const localizedBudgetHeaders = this.localizeHeaders(BUDGET_ZBC);
                return this.returnExcelColumn(localizedBudgetHeaders, BUDGET_ZBC_TEMPDATA);
            case 'Labour':
                const localizedLabourHeaders = this.localizeHeaders(Labour);
                return this.returnExcelColumn(localizedLabourHeaders, LabourTempData);
            case ZBCADDMOREOPERATION:
                const localizedAddMoreOperationHeaders = this.localizeHeaders(ZBCOperation);
                return this.returnExcelColumn(localizedAddMoreOperationHeaders, ZBCOperationTempData);
            default:
                return 'foo';
        }
    }

    /**
    * @method renderVBCSwitch
    * @description Switch case for different xls file head according to master
    */
    renderVBCSwitch = (master, bopType) => {
        let updatedLabels;
        switch (master) {
            case 'RM':
                if (!this.props.isImport) {
                    const localizedHeaders = this.localizeHeaders(RMDomesticVBC);
                    return this.returnExcelColumn(checkVendorPlantConfig(localizedHeaders), RMDomesticVBCTempData, true);
                } else {
                    const localizedHeaders = this.localizeHeaders(RMImportVBC);
                    return this.returnExcelColumn(checkVendorPlantConfig(localizedHeaders), RMImportVBCTempData);
                }
            case 'Operation':
                const localizedOperationHeaders = this.localizeHeaders(VBCOperationSmallForm);

                return this.returnExcelColumn(checkLabourRateConfigure(localizedOperationHeaders), VBCOperationTempData, true);
            case 'Machine':
                const localizedMachineHeaders = this.localizeHeaders(MachineVBC);
                return this.returnExcelColumn(checkVendorPlantConfig(localizedMachineHeaders), MachineVBCTempData);
            case `${showBopLabel()} Domestic`:
                if (bopType === DETAILED_BOP) {
                    const localizedBOPHeaders = this.localizeHeaders(BOP_DETAILED_DOMESTIC);
                    ({ updatedLabels } = updateBOPValues(localizedBOPHeaders, [], bopMasterName, 'label'));

                    return this.returnExcelColumn(checkVendorPlantConfig(updatedLabels, '', true), BOP_DETAILED_DOMESTIC_TempData);
                } else {
                    const localizedBOPHeaders = this.localizeHeaders(BOP_VBC_DOMESTIC);
                    ({ updatedLabels } = updateBOPValues(localizedBOPHeaders, [], bopMasterName, 'label'));

                    return this.returnExcelColumn(checkVendorPlantConfig(updatedLabels, '', true), BOP_VBC_DOMESTIC_TempData);
                }
            case `${showBopLabel()} Import`:
                if (bopType === DETAILED_BOP) {
                    const localizedBOPHeaders = this.localizeHeaders(BOP_DETAILED_IMPORT);
                    ({ updatedLabels } = updateBOPValues(localizedBOPHeaders, [], bopMasterName, 'label'));

                    return this.returnExcelColumn(checkVendorPlantConfig(updatedLabels, '', true), BOP_DETAILED_IMPORT_TempData);
                } else {
                    const localizedBOPHeaders = this.localizeHeaders(BOP_VBC_IMPORT);
                    ({ updatedLabels } = updateBOPValues(localizedBOPHeaders, [], bopMasterName, 'label'));

                    return this.returnExcelColumn(checkVendorPlantConfig(updatedLabels, '', true), BOP_VBC_IMPORT_TempData);
                }
            case `Overhead`:
                const localizedOverheadHeaders = this.localizeHeaders(OverheadVBC);

                return this.returnExcelColumn(localizedOverheadHeaders, addDynamicModelType(OverheadVBC_TempData, this.props?.modelText));
            case `Profit`:
                const localizedProfitHeaders = this.localizeHeaders(ProfitVBC);
                return this.returnExcelColumn(localizedProfitHeaders, addDynamicModelType(ProfitTempDataVBC, this.props?.modelText));
            case 'Actual Volume':
                const localizedVolumeHeaders = this.localizeHeaders(VOLUME_ACTUAL_VBC);
                return this.returnExcelColumn(checkVendorPlantConfig(localizedVolumeHeaders), VOLUME_ACTUAL_VBC_TEMPDATA);
            case 'Budgeted Volume':
                const localizedBudgetedVolumeHeaders = this.localizeHeaders(VOLUME_BUDGETED_VBC);
                return this.returnExcelColumn(checkVendorPlantConfig(localizedBudgetedVolumeHeaders), VOLUME_BUDGETED_VBC_TEMPDATA);
            case 'Interest Rate':
                const localizedInterestRateHeaders = this.localizeHeaders(VBCInterestRate);
                return this.returnExcelColumn(checkInterestRateConfigure(localizedInterestRateHeaders), VBCInterestRateTempData);
            case 'Budget':
                const localizedBudgetHeaders = this.localizeHeaders(BUDGET_VBC);
                return this.returnExcelColumn(localizedBudgetHeaders, BUDGET_VBC_TEMPDATA);
            case 'Labour':
                const localizedLabourHeaders = this.localizeHeaders(Labour);
                return this.returnExcelColumn(localizedLabourHeaders, LabourTempData);
            case VBCADDMOREOPERATION:
                const localizedAddMoreOperationHeaders = this.localizeHeaders(VBCOperation);
                return this.returnExcelColumn(checkLabourRateConfigure(localizedAddMoreOperationHeaders), VBCOperationTempData, true);
            default:
                return 'foo';
        }
    }
    /**
     * @method renderVBCSwitch
     * @description Switch case for different xls file head according to master
     */
    renderCBCSwitch = (master) => {
        let updatedLabels;
        switch (master) {
            case 'RM':
                if (!this.props.isImport) {
                    const localizedRMHeaders = this.localizeHeaders(RMDomesticCBC);
                    return this.returnExcelColumn(checkVendorPlantConfig(localizedRMHeaders), RMDomesticCBCTempData, true);
                } else {
                    const localizedRMHeaders = this.localizeHeaders(RMImportCBC);
                    return this.returnExcelColumn(checkVendorPlantConfig(localizedRMHeaders), RMImportCBCTempData);
                }
            case 'Operation':
                const localizedOperationHeaders = this.localizeHeaders(CBCOperationSmallForm);
                return this.returnExcelColumn(checkLabourRateConfigure(localizedOperationHeaders), CBCOperationTempData, true);
            case 'Machine':
                const localizedMachineHeaders = this.localizeHeaders(MachineCBC);
                return this.returnExcelColumn(checkVendorPlantConfig(localizedMachineHeaders), MachineCBCTempData);
            case `${showBopLabel()} Domestic`:
                const localizedBOPHeaders = this.localizeHeaders(BOP_CBC_DOMESTIC);
                ({ updatedLabels } = updateBOPValues(localizedBOPHeaders, [], bopMasterName, 'label'));

                return this.returnExcelColumn(checkVendorPlantConfig(updatedLabels, CBCTypeId, true), BOP_CBC_DOMESTIC_TempData);
            case `${showBopLabel()} Import`:
                const localizedBOPImportHeaders = this.localizeHeaders(BOP_CBC_IMPORT);
                ({ updatedLabels } = updateBOPValues(localizedBOPImportHeaders, [], bopMasterName, 'label'));

                return this.returnExcelColumn(checkVendorPlantConfig(updatedLabels, CBCTypeId, true), BOP_CBC_IMPORT_TempData);
            case `Overhead`:
                const localizedOverheadHeaders = this.localizeHeaders(OverheadCBC);
                return this.returnExcelColumn(localizedOverheadHeaders, addDynamicModelType(OverheadCBC_TempData, this.props?.modelText));
            case `Profit`:
                const localizedProfitHeaders = this.localizeHeaders(ProfitCBC);
                return this.returnExcelColumn(localizedProfitHeaders, addDynamicModelType(ProfitTempDataCBC, this.props?.modelText));
            case 'Actual Volume':
                const localizedVolumeHeaders = this.localizeHeaders(VOLUME_ACTUAL_CBC);
                return this.returnExcelColumn(checkVendorPlantConfig(localizedVolumeHeaders), VOLUME_ACTUAL_CBC_TEMPDATA);
            case 'Budgeted Volume':
                const localizedBudgetedVolumeHeaders = this.localizeHeaders(VOLUME_BUDGETED_CBC);
                return this.returnExcelColumn(checkVendorPlantConfig(localizedBudgetedVolumeHeaders), VOLUME_BUDGETED_CBC_TEMPDATA);
            case 'Interest Rate':
                const localizedInterestRateHeaders = this.localizeHeaders(CBCInterestRate);
                return this.returnExcelColumn(checkInterestRateConfigure(localizedInterestRateHeaders), CBCInterestRateTempData);
            case 'Budget':
                const localizedBudgetHeaders = this.localizeHeaders(BUDGET_CBC);
                return this.returnExcelColumn(localizedBudgetHeaders, BUDGET_CBC_TEMPDATA);
            case 'Labour':
                const localizedLabourHeaders = this.localizeHeaders(Labour);
                return this.returnExcelColumn(localizedLabourHeaders, LabourTempData);
            case CBCADDMOREOPERATION:
                const localizedAddMoreOperationHeaders = this.localizeHeaders(CBCOperation);
                return this.returnExcelColumn(checkLabourRateConfigure(localizedAddMoreOperationHeaders), CBCOperationTempData, true);
            default:
                return 'foo';
        }
    }

    /**
    * @method returnExcelColumn
    * @description Used to get excel column names
    */
    returnExcelColumn = (data = [], TempData, isNoteColExist = false) => {
        const { fileName, failedData, isFailedFlag } = this.props;

        let dataList = [...data]


        if (isFailedFlag) {
            //BELOW CONDITION TO ADD 'REASON' COLUMN WHILE DOWNLOAD EXCEL SHEET IN CASE OF FAILED
            let isContentReason = dataList.filter(d => d.label === 'Reason')
            if (isContentReason.length === 0) {
                let addObj = { label: 'Reason', value: 'Reason' }
                dataList.push(addObj)
            }
        }
        // Replace labels based on the file name containing "BOP domestic" or "BOP import"

        if (isNoteColExist && failedData) {
            const notesInTemp = TempData.some(item => item.Note)
            const notesInFailed = failedData.some(item => item.Note);
            if (notesInTemp && !notesInFailed) {
                // Add Notes from TempData to failedData
                for (let i = 0; i < failedData.length && i < TempData.length; i++) {
                    failedData[i].Note = TempData[i].Note || failedData[i].Note;
                }
            }
        }

        return (<ExcelSheet data={isFailedFlag ? failedData : TempData} name={fileName}>

            {dataList && dataList.map((ele, index) => <ExcelColumn key={index} label={ele.label} value={ele.value} style={ele.style} />)}
        </ExcelSheet>);
    }

    render() {
        const { isFailedFlag, fileName, isZBCVBCTemplate, isMachineMoreTemplate, costingTypeId, bopType } = this.props;
        const downloadFileName = (fileName === 'RM')
            ? (this.props.isImport ? 'RM Import' : 'RM Domestic')
            : fileName;
        // DOWNLOAD FILE:- CALLED WHEN ZBC FILE FAILED   hideElement={true}
        // ZBC_MACHINE_MORE THIS IS ADDITIONAL CONDITION ONLY FOR MACHINE MORE DETAIL FROM MACHINE MASTER
        if (isFailedFlag && (costingTypeId === ZBCTypeId || costingTypeId === ZBCADDMOREOPERATION) && (fileName === 'RM' || fileName === 'Operation' || fileName === 'Machine' || fileName === `${showBopLabel()} Domestic` || fileName === `${showBopLabel()} Import` || fileName === 'Actual Volume' || fileName === 'Budgeted Volume' || fileName === 'Interest Rate' || fileName === 'Budget')) {
            return (
                <ExcelFile hideElement={true} filename={`${downloadFileName} ZBC`} fileExtension={'.xls'} >
                    {isMachineMoreTemplate || costingTypeId === ZBCADDMOREOPERATION ? this.renderZBCSwitch(costingTypeId) : this.renderZBCSwitch(fileName)}
                </ExcelFile>
            );
        }
        if (isFailedFlag && (costingTypeId === ZBCADDMORE || costingTypeId === VBCADDMORE || costingTypeId === CBCADDMORE) && (fileName === 'Machine')) {

            return (
                <ExcelFile hideElement={true} filename={"Add more details"} fileExtension={'.xls'} >
                    {isMachineMoreTemplate || (costingTypeId === ZBCADDMORE || costingTypeId === VBCADDMORE || costingTypeId === CBCADDMORE) ? this.renderZBCSwitch(costingTypeId) : ""}
                </ExcelFile>
            );
        }

        // DOWNLOAD FILE:- CALLED WHEN VBC FILE FAILED
        if (isFailedFlag && (costingTypeId === VBCTypeId || costingTypeId === VBCADDMOREOPERATION || bopType === DETAILED_BOP) && (fileName === 'RM' || fileName === 'Operation' || fileName === 'Machine' || fileName === `${showBopLabel()} Domestic` || fileName === `${showBopLabel()} Import` || fileName === 'Actual Volume' || fileName === 'Budgeted Volume' || fileName === 'Interest Rate' || fileName === 'Budget')) {

            return (
                <ExcelFile hideElement={true} filename={`${downloadFileName}VBC`} fileExtension={'.xls'} >
                    {costingTypeId === VBCADDMOREOPERATION ? this.renderVBCSwitch(costingTypeId) : this.renderVBCSwitch(fileName, bopType)}
                </ExcelFile>
            );
        }
        // DOWNLOAD FILE:- CALLED WHEN CBC FILE FAILED
        if (isFailedFlag && (costingTypeId === CBCTypeId || costingTypeId === CBCADDMOREOPERATION) && (fileName === 'RM' || fileName === 'Operation' || fileName === 'Machine' || fileName === `${showBopLabel()} Domestic` || fileName === `${showBopLabel()} Import` || fileName === 'Actual Volume' || fileName === 'Budgeted Volume' || fileName === 'Interest Rate' || fileName === 'Budget')) {

            return (
                <ExcelFile hideElement={true} filename={`${downloadFileName} CBC`} fileExtension={'.xls'} >
                    {costingTypeId === CBCADDMOREOPERATION ? this.renderCBCSwitch(costingTypeId) : this.renderCBCSwitch(fileName)}
                </ExcelFile>
            );
        }
        // DOWNLOAD FILE:- CALLED WHEN FILE FAILED APART FROM ZBC AND VBC
        if (isFailedFlag && (fileName === 'RM Specification' || fileName === 'Vendor' || fileName === 'Overhead' || fileName === 'Profit' || fileName === 'Fuel' || fileName === 'Labour' || fileName === 'Part Component' || fileName === 'Product Component' || fileName === ASSEMBLYORCOMPONENTSRFQ || fileName === BOUGHTOUTPARTSRFQ || fileName === RAWMATERIALSRFQ || fileName === 'Index' || fileName === 'Index Data' || fileName === 'Commodity (In Index)' || fileName === 'Commodity Standard' || fileName === 'Commodity Standardization' || fileName === SAP_PUSH)) {

            return (
                <ExcelFile hideElement={true} filename={fileName} fileExtension={'.xls'} >
                    {this.renderSwitch(fileName)}
                </ExcelFile>
            );
        }

        // DISPLAY RADIO BUTTON ZBC AND VBC, WITH FILE DOWNLOAD BUTTON
        if (isZBCVBCTemplate) {
            return (
                <>
                    {(costingTypeId === ZBCTypeId || costingTypeId === ZBCADDMOREOPERATION) &&
                        <ExcelFile filename={costingTypeId === ZBCADDMOREOPERATION ? 'ZBC More Details' : `${downloadFileName} ZBC`} fileExtension={'.xls'} element={<button type="button" className={'btn btn-primary pull-right w-100'}><div class="download"></div> Download</button>}>
                            {costingTypeId !== ZBCADDMOREOPERATION ? this.renderZBCSwitch(fileName) : this.renderZBCSwitch(costingTypeId)}
                        </ExcelFile>}

                    {(costingTypeId === VBCTypeId || costingTypeId === VBCADDMOREOPERATION) &&
                        <ExcelFile filename={costingTypeId === VBCADDMOREOPERATION ? 'VBC More Details' : `${downloadFileName} VBC`} fileExtension={'.xls'} element={<button type="button" className={'btn btn-primary pull-right w-100'}><div class="download"></div> Download</button>}>

                            {(costingTypeId === VBCADDMOREOPERATION ? this.renderVBCSwitch(Number(costingTypeId)) : this.renderVBCSwitch(fileName))}
                        </ExcelFile>}
                    {(costingTypeId === CBCTypeId || costingTypeId === CBCADDMOREOPERATION) &&
                        <ExcelFile filename={costingTypeId === CBCADDMOREOPERATION ? 'CBC More Details' : `${downloadFileName} CBC`} fileExtension={'.xls'} element={<button type="button" className={'btn btn-primary pull-right w-100'}><div class="download"></div> Download</button>}>
                            {costingTypeId !== CBCADDMOREOPERATION ? this.renderCBCSwitch(fileName) : this.renderCBCSwitch(costingTypeId)}
                        </ExcelFile>}
                    {bopType === DETAILED_BOP &&
                        <ExcelFile filename={`${fileName} VBC`} fileExtension={'.xls'} element={<button type="button" className={'btn btn-primary pull-right w-100'}><div class="download"></div> Download</button>}>
                            {fileName ? this.renderVBCSwitch(fileName, bopType) : ''}
                        </ExcelFile>}
                    {/* ZBC_MACHINE_MORE THIS IS ADDITIONAL CONDITION ONLY FOR MACHINE MORE DETAIL FROM MACHINE MASTER */}
                    {(costingTypeId === ZBCADDMORE || costingTypeId === VBCADDMORE || costingTypeId === CBCADDMORE) &&
                        <ExcelFile filename={"Add more details"} fileExtension={'.xls'} element={<button type="button" className={'btn btn-primary pull-right w-100'}><div class="download"></div> Download</button>}>
                            {fileName ? this.renderZBCSwitch(costingTypeId) : ''}
                        </ExcelFile >}
                </>
            );
        }

        // DISPLAY DOWNLOAD FILE BUTTON EXCEPT ZBC AND VBC TEMPLATES
        return (
            <ExcelFile filename={fileName} fileExtension={'.xls'} element={< button type="button" className={'btn btn-primary pull-right w-100'} > <div class="download"></div> Download</button>}>
                {fileName ? this.renderSwitch(fileName) : ''}
            </ExcelFile >
        );
    }
}

export default withTranslation('MasterLabels')(Downloadxls);
// CR2-I19
